import React, { useState, useRef } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { useLocation } from "react-router-dom";
import Footer from "../../component/Footer/Footer";
import Buttons from "../../component/ButtonsComponent/PgmButtons";
import "./pgmlist.scss";
import PgmTextField from "../../component/PgmTextfieldComponent/PgmTextField";
import { pgmListAction, searchinputAction, pageinputAction, pgmFilterButtonAction } from "../../actions/pgmAction";
import { downloadPartnerAction } from "../../actions/downloadAction";
import { fetchAreaExecutedListAction } from "../../actions/areaExecutiveAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { safeEncode } from "../../common/encoder";
import Loader from "../../component/loaderComponent/Loader";
import Paginations from "../../component/Pagination/PgmTextField";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";
import NodataFound from "../../component/NodataFound";
import { getCountryAction } from "../../actions/countryAction";
import { safeDecode } from "../../common/decoder";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";


function PgmList() {
  const [pgmList, setPgmList] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [countryDataLoading, setCountryDataLoading] = useState(true);
  const searchdata = useSelector((state) => state.pgmsearch);
  const pagedata = useSelector((state) => state.pgmlistpage);
  const filterbutton = useSelector((state) => state.pgmButton);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(pagedata?.page);
  const [startIndex, setStartIndex] = useState(1);
  const location = useLocation();
  const activeButtonData = location.state || "";
  const [filter, setFilter] = useState(activeButtonData || filterbutton.button);
  const [activeButton, setActiveButton] = useState(activeButtonData || filterbutton.button);
  const { loading, areaExecutiveList, error } = useSelector((state) => state.getAreaExecutiveListReducer)
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const searchInputRef = useRef(null);
  const tableRef = useRef(null);
  const [startCount, setStartCount] = useState();
  const [endCount, setEndCount] = useState();
  const [totalCount, setTotalCount] = useState();
  const [selectedRemarks, setSelectedRemarks] = useState('');
  const [pendingStatus, setPendingStatus] = useState();
  const [selectedExecutiveId, setSelectedExecutiveId] = useState('');

  const handleStatusDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedRemarks(selectedValue);
  };

  const resetStatusFilter = () => {
    setSelectedRemarks("");
    PgmListData(filter, fromDate, toDate, "");
  };

  const [search, setSearch] = useState(searchdata?.searchdata?.data?.value);

  useEffect(() => {
    if (filter !== "") {
      PgmListData(filter, fromDate, toDate, selectedRemarks, selectedExecutiveId);
    }
  }, [page]);

  useEffect(() => {
    if (search?.length === 0) {
      PgmListData(filter, fromDate, toDate, selectedRemarks, selectedExecutiveId);
    }
  }, [search])

  useEffect(() => {
    dispatch(fetchAreaExecutedListAction())
  }, [])

  useEffect(() => {
    CountryListData();
    handleChangeLanguage(language);
    if (filter !== "") {
      PgmListData(filter, fromDate, toDate, selectedRemarks, selectedExecutiveId);
    }
  }, [filter]);

  const handlePageChange = (event, value) => {
    dispatch(pageinputAction(value));
    setPage(value);
  };

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  async function CountryListData() {
    setCountryDataLoading(true)
    setIsLoading(true);
    const Country_id = safeDecode(Cookies.get('country_id'));
    let response = await dispatch(getCountryAction());
    if (response?.status === HTTP_STATUS.SUCCESS) {
      Cookies.set("country_name", safeEncode(response?.data?.data?.find((item) => (item?.id) === parseInt(Country_id))?.country_name), {
        expires: 1,
        sameSite: "None",
        secure: true,
      });
      setIsLoading(false);
    }
    setCountryDataLoading(false)
  }

  async function PgmListData(parm, fromDate = '', toDate = '', selectedRemarks, selectedExecutiveId = '') {
    setIsLoading(true);
    setPgmList(null)
    setFilter(parm);
    dispatch(pgmFilterButtonAction(parm));
    const newStartIndex = (page - 1) * 15 + 1;
    setStartIndex(newStartIndex);
    let response;
    if (search === undefined) {
      response = await dispatch(pgmListAction(parm ? parm : '', page, '', fromDate, toDate, selectedRemarks, selectedExecutiveId));
      setStartCount(response?.data?.start_index);
      setEndCount(response?.data?.end_index);
      setTotalCount(response?.data?.count);
      setPendingStatus(response?.data?.results?.meta);
    } else {
      response = await dispatch(pgmListAction(parm ? parm : '', page, search, fromDate, toDate, selectedRemarks, selectedExecutiveId));
      setPendingStatus(response?.data?.results?.meta);
    }

    if (response?.status === HTTP_STATUS.SUCCESS) {
      if (response.data.count % 15 === 0) {
        setCount(Math.floor(response?.data?.count / 15));
      } else {
        setCount(Math.floor(response?.data?.count / 15 + 1));
      }
      setPgmList(response?.data?.results?.data);
      setStartCount(response?.data?.start_index);
      setEndCount(response?.data?.end_index);
      setTotalCount(response?.data?.count);
    }

    setIsLoading(false);
  }

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const handleExecutiveChange = (event) => {
    const selectedId = event.target.value;
    setSelectedExecutiveId(selectedId)
    if (selectedId === "") {
      PgmListData(filter, fromDate, toDate, selectedRemarks, "");
    }
  }

  const handleChange = (evt) => {
    const value = evt.target.value;
    setPage(1);
    setSearch(value.replace(/^ +/gm, ""));
    var seardata = {
      value: evt.target.value,
    };
    dispatch(searchinputAction(seardata));
    if (page != 1) {
      dispatch(pageinputAction(1));
      setPage(1)
    }
  };

  async function SearchPgmList() {
    if (!search && !fromDate && !toDate && !selectedRemarks && !selectedExecutiveId) {
      NotificationManager.error("Please enter value");
      return false;
    }
    const defaultPage = 1;
    if (page != 1) {
      dispatch(pageinputAction(1));
      setPage(1)
    }
    setIsLoading(true);
    const newStartIndex = (page - 1) * 15 + 1;
    setStartIndex(newStartIndex);
    let response = await dispatch(pgmListAction(filter, defaultPage ? defaultPage : page, search || '', fromDate, toDate, selectedRemarks || "", selectedExecutiveId || ""));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      if (response.data.count % 15 === 0) {
        setCount(Math.floor(response?.data?.count / 15));
      } else {
        setCount(Math.floor(response?.data?.count / 15 + 1));
      }
      setPgmList(response?.data?.results?.data);
      setTotalCount(response?.data?.count);
      setStartCount(response?.data?.start_index);
      setEndCount(response?.data?.end_index);
      setIsLoading(false);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  }
  const handlebuttonClick = (data) => {
    setFilter(data)
    dispatch(pgmFilterButtonAction(data));
    dispatch(pageinputAction(1));
    setPage(1);
    setActiveButton(data);
    setFromDate('');
    setToDate('');
    setSelectedRemarks('');
    setSelectedExecutiveId('')
    setSearch('');
    if (page === 1) {
      PgmListData(data);
    }
  };

  async function downloadPartnerExcel() {
    try {
      const fileBlob = await dispatch(downloadPartnerAction(activeButton, selectedExecutiveId));

      if (fileBlob) {
        const blobUrl = URL.createObjectURL(fileBlob);
        const newWindow = window.open(blobUrl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          NotificationManager.error('Popup blocked. Please allow popups for this website');
        }
      }
    } catch (error) {
      NotificationManager.error('Error downloading file:', error);
    }
  }

  const handleAddPartnerButtonClick = (index, data) => {
    setActiveButton(index);
    navigate(`/partner`);
  };

  const pgmDetails = (Id) => {
    window.scroll(0, 0);
    const encodeid = safeEncode(Id);
    navigate(`/pgmdetails/${encodeid}`);
  };

  return (
    <div className="pgm-lists-containers">
      <div className="pgmlist_container">
        <div className="pgmlistmain">
          <div className="header_border">
            <p className="pgm-list-header-text">TVS &gt; {t('pgmlist.pageTitle')}</p>
          </div>
          <Buttons
            PgmListData={PgmListData}
            page={page}
            setPage={setPage}
            handlebuttonClick={handlebuttonClick}
            handleAddPartnerButtonClick={handleAddPartnerButtonClick}
            activeButton={activeButton}
            activeButtonData={activeButtonData}
            downloadPartnerExcel={downloadPartnerExcel}
          />
          <PgmTextField
            searchInputRef={searchInputRef}
            search={search}
            handleChange={handleChange}
            SearchPgmList={SearchPgmList}
            fromDate={fromDate}
            toDate={toDate}
            handleFromDateChange={handleFromDateChange}
            handleToDateChange={handleToDateChange}
            handleStatusDropdownChange={handleStatusDropdownChange}
            selectedRemarks={selectedRemarks}
            activeButton={activeButton}
            pendingStatus={pendingStatus}
            resetStatusFilter={resetStatusFilter}
            selectedExecutiveId={selectedExecutiveId}
            areaExecutiveList={areaExecutiveList}
            handleExecutiveChange={handleExecutiveChange}
          />
          <div>
            {pgmList === null ? (
              <Loader />
            ) : pgmList.length > 0 ? (
              <div className="tabledata">
                <div className="desktop-view">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="tablesth"> {t('pgmlist.sNo')}</th>
                        <th className="tablesth">{t('pgmlist.userName')}</th>
                        <th className="tablesth">{t('pgmlist.mobileNumber')}</th>
                        <th className="tablesth">{t('pgmlist.shopName')}</th>
                        <th className="tablesth">{t('common.city')}</th>
                        <th className="tablesth">{t('common.provinceState')}</th>
                        <th className="tablesth">{t('areaExecutive.areaexecutive')}</th>
                        <th className="tablesth">{t('pgmlist.pinCode')}</th>
                        {activeButton === 'pending' && <th className="tablesth">{t('pgmlist.status')}</th>}
                        {hasPermission(PERMISSIONS.CAN_VIEW_PROFILE_DETAILS) && <th className="tablesth"></th>}
                      </tr>
                    </thead>
                    <tbody>
                      {pgmList.map((data, ind) => (
                        <tr className="tabletd" ref={tableRef} key={ind}>
                          <td>{ind + startIndex}</td>
                          <td className="tabletd-name" title={data?.name}>{data?.name}</td>
                          <td>{data?.mobile_number}</td>
                          <td className="tabletd-shop-name" title={data?.shop_name}>{data?.shop_name}</td>
                          <td className="tabletd-location">{data?.city}</td>
                          <td className="tabletd-location">{data?.province}</td>
                          <td className="tabletd-location">{data?.area_executive}</td>
                          <td>{data?.pincode}</td>
                          {activeButton === 'pending' && <td className="tabletd-status" title={data?.remarks}>{data?.remarks}</td>}
                          {hasPermission(PERMISSIONS.CAN_VIEW_PROFILE_DETAILS) && (
                            <td className="tabletd_view" onClick={() => pgmDetails(data?.id)}>
                              {t('common.view')}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Card View for Tablet & Mobile */}
                <div className="mobile-view">
                  {pgmList.map((data, ind) => (
                    <div className="cards" key={ind}>
                      <div className="card-header">
                        <p><b>{t('pgmlist.userName')}:</b> {data?.name}</p>
                      </div>
                      <div className="card-body">
                        <p><strong>{t('pgmlist.mobileNumber')}:</strong> {data?.mobile_number}</p>
                        <p><strong>{t('pgmlist.shopName')}:</strong> {data?.shop_name}</p>
                        <p><strong>{t('common.city')}:</strong> {data?.city}</p>
                        <p><strong>{t('common.provinceState')}:</strong> {data?.province}</p>
                        <p><strong>{t('pgmlist.pinCode')}:</strong> {data?.pincode}</p>
                        {data?.area_executive && <p><b>{t('areaExecutive.areaexecutive')}:</b> <span className="mobile-badge">{data?.area_executive}</span></p>}
                        {activeButton === 'pending' && (
                          <p><strong>{t('pgmlist.status')}:</strong> {data?.remarks}</p>
                        )}
                      </div>
                      {hasPermission(PERMISSIONS.CAN_VIEW_PROFILE_DETAILS) && (
                        <button className="view-btn" onClick={() => pgmDetails(data?.id)}>
                          {t('common.view')}
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                {/* Display Count */}
                <div>
                  <span className="display-count">{`${t('pgmlist.displaying')} ${startCount} ${t('common.to')} ${endCount} ${t('common.out_of')} ${totalCount}`}</span>
                </div>
              </div>
            ) : (
              <NodataFound />
            )}
          </div>

          <div className="pagination_div">
            <Paginations
              defaultPage={1}
              count={count}
              page={page}
              handlePageChange={handlePageChange}
            />
          </div>

        </div>
      </div>
    </div>
  );
}

export default PgmList;
